export default{
  'full': 'Editar/Excluir',
  'edit': 'Editar',
  'view': 'Visualizar',
  'none': 'Sem acesso',
  options: [
    { value: 'full', text: 'Editar/Excluir' },
    { value: 'edit', text: 'Editar' },
    { value: 'view', text: 'Visualizar' },
    { value: 'none', text: 'Sem acesso' }
  ],
}
